import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider, Button, Stack, Modal, } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { esignToolApi } from '../../services/esignApi';
import { esignIcons } from './icons';
import { apiEndpoint } from '../../urls';
import Loader from '../Loader';
import { useLogger } from '../../hooks/useLogger';
import { toast } from "react-toastify";
import { heIL } from '@mui/x-date-pickers/locales';

export default function ImportSigners({importSigners, setImportSigners, fetchSignersData}) {
    const logEvent = useLogger();
    const dispatch = useDispatch();
    const fileInputRef = React.useRef(null);
    const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
    const [loader, setLoader] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [selectedSigners, setSelectedSigners] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [processCSV, setProcessCSV] = useState(false);
    const [csvSuccess, setCsvSuccess] = useState(false);
    const [csvUnsuccess, setCsvUnsuccess] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);
    const { uploadedDocument} = useSelector((state) => state.uploadDocument);

    const handleFileUpload = async (event) => {
        logEvent('Clicked', 'Select CSV', 'add signers');
        const file = event.target.files[0];

        if (!file) return;

        if (file.type !== "text/csv") {
            toast.error("Please upload a CSV file only");
            event.target.value = null;
            return;
        }
        setSelectedFile(file);
        setSelectedSigners(true);
        setImportSigners(false);
        event.target.value = null;
    };


    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const file = event.dataTransfer.files[0];
        if (file) {
            console.log('File dropped:', file.name);
        }
    };

    const handleProceed = async () => {
        if (!selectedFile) return;

        setProcessCSV(true);
        try {
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("document_id", uploadedDocument?.data?.document_id);

            const response = await esignToolApi.uploadCSV(formData);
            console.log(response)
            setSelectedSigners(false);
            setSelectedFile(null);
            setProcessCSV(false);
            if(response?.status)
            {
                setCsvSuccess(true);
                setTimeout(() => {
                    setFadeOut(true);
                    setTimeout(() => {
                        setCsvSuccess(false);
                        setFadeOut(false);
                        fetchSignersData();
                    }, 500);
                }, 1500);
            }
            else {
                setCsvUnsuccess(true)
            }
        } catch (error) {
            toast.error("Upload failed!");
            console.error(error);
        } finally {
            setProcessCSV(false);
        }
    };

    const formatFileSize = (bytes) => {
        const kb = bytes / 1024;
        const mb = kb / 1024;

        if (mb >= 1) {
            return `${mb.toFixed(2)} MB`;
        } else {
            return `${kb.toFixed(2)} KB`;
        }
    };


    
    return (
        <>
            <Modal open={importSigners} onClose={() => setImportSigners(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "720px",
                        height: "417px",
                        backgroundColor: "#fff",
                        boxShadow: 24,
                        overflow: "auto",
                        borderRadius: "20px",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                        <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Import Signers</Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "34px"}}>
                            <a href="/sample_bulk_signers.csv" download style={{ fontSize: "17px", fontWeight: 500, color: "#185CB7",}}>Download Sample CSV</a>
                            <Button sx={{minWidth: "auto", padding: "0", "&:hover": {background: "none",}}} onClick={() => setImportSigners(false)}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M29.3337 15.9997C29.3337 8.63588 23.3641 2.66634 16.0003 2.66634C8.63653 2.66634 2.66699 8.63588 2.66699 15.9997C2.66699 23.3635 8.63653 29.333 16.0003 29.333C23.3641 29.333 29.3337 23.3635 29.3337 15.9997Z" fill="#1D1D1D"/>
                                <path d="M19.9991 20L12 12M12.0009 20L20 12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </Button>
                        </Box>
                    </Box>
                    <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
                    <Box sx={{ p: "0 30px 0 30px", width: "100%", margin: "auto" }}>
                        <Box style={{ display: "flex", flexDirection: "column", border: "1px dashed #BDBDBD", borderRadius: "12px", background: "#F6F6F6", padding: "37px 0" }}>
                            <Box 
                                onDragOver={handleDragOver}
                                onDrop={handleDrop}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    gap: "17px",
                                }}
                                onClick={() => fileInputRef.current?.click()}>
                                <Box component="img" src={`${process.env.PUBLIC_URL}/images/excelIcon.svg`} alt="excelIcon" height="71px" />
                                <Typography variant="p" sx={{ background: 'transparent', color:'#1D1D1D', fontSize: '18px', fontWeight: '600' }}>Choose a file or Drag and Drop file here</Typography>

                                <Typography variant="p" sx={{ background: 'transparent', fontSize: '14px', color: '#A3A3A3', fontWeight: '400' }}>Upload CSV (Max Size 50Mb)</Typography>
                                
                            </Box>
                            <Button
                            variant="contained"
                            sx={{
                                mt: "28px",
                                width: '180px',
                                height: 46,
                                color: "#fff",
                                background: "#185CB7",
                                textTransform: "none",
                                fontSize: "16px",
                                borderRadius: "10px",
                                boxShadow: "none",
                                fontWeight: "500",
                                "&:hover": { background: "#185CB7" },
                                alignSelf: "center"
                            }}
                            onClick={() => fileInputRef.current?.click()}
                            >
                            Import File
                            </Button>
                            <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileUpload} accept=".csv,text/csv" />                            
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={selectedSigners} onClose={() => setSelectedSigners(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "476px",
                        height: "380px",
                        backgroundColor: "#fff",
                        boxShadow: 24,
                        overflow: "auto",
                        borderRadius: "20px",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                        <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Import Signers</Typography>
                    </Box>
                    <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
                    <Box sx={{ p: "0 30px 0 30px", width: "100%", margin: "auto" }}>
                        <Box style={{ display: "flex", border: "1px solid #EDEDED", borderRadius: "12px", background: "#F6F6F6", padding: "23px 38px 0 38px", height: "118px", gap: "17px" }}>
                            <Box component="img" src={`${process.env.PUBLIC_URL}/images/csvIcon.svg`} alt="csvIcon" height="94px" />
                            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                <Typography variant="p" sx={{ background: 'transparent', color:'#1D1D1D', fontSize: '18px', fontWeight: '500' }}>{selectedFile?.name}</Typography>
                                <Typography variant="p" sx={{ background: 'transparent', color:'#828282', fontSize: '14px', fontWeight: '400' }}>File size - {selectedFile ? formatFileSize(selectedFile.size) : ""}</Typography>
                            </Box>
                        </Box>
                        <Typography sx={{ m: "auto", background: 'transparent', color:'#5C5C5C', fontSize: '14px', fontWeight: '400', textAlign: "center", mt: "22px", width: "90%" }}>Click to proceed your imported  signers into the signers list.</Typography>
                    </Box>
                    <Divider />
                        
                    <Box sx={{ p: "0 30px", mb: "16px", position: "relative", }}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: "16px", gap: 2 }}>
                            <Button variant="contained" sx={{ width: '130px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => {setSelectedSigners(false); setSelectedFile(null)}} >
                                Cancel
                            </Button>
                            <Button variant="contained" sx={{ width: '155px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"} }} onClick={handleProceed} >
                                Proceed
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={processCSV}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "528px",
                        height: "380px",
                        backgroundColor: "#fff",
                        boxShadow: 24,
                        overflow: "auto",
                        borderRadius: "20px",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                        <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Import Signers</Typography>
                    </Box>
                    <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
                    <Box sx={{ p: "0 30px 0 30px", width: "100%", margin: "auto" }}>
                        <Box component="img" src={`${process.env.PUBLIC_URL}/images/csv_loader.gif`} alt="csv_loader" width="100%" />
                        <Typography sx={{ m: "auto", background: 'transparent', color:'#3D3D3D', fontSize: '18px', fontWeight: '500', textAlign: "center", mt: "20px", }}>We are fetching your signers list, Please wait...</Typography>
                    </Box>
                </Box>
            </Modal>

            <Modal open={csvSuccess} onClose={() => setCsvSuccess(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "528px",
                        height: "320px",
                        backgroundColor: "#fff",
                        boxShadow: 24,
                        overflow: "auto",
                        borderRadius: "20px",
                        display: "flex",
                        flexDirection: "column",
                        opacity: fadeOut ? 0 : 1,
                        transition: "opacity 0.5s ease",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                        <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Import Signers</Typography>
                    </Box>
                    <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
                    <Box sx={{ p: "0 30px 0 30px", width: "100%", margin: "auto" }}>
                        <Box display="flex" justifyContent="center">
                            <svg width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M85 42.5C85 65.9721 65.9721 85 42.5 85C19.0279 85 0 65.9721 0 42.5C0 19.0279 19.0279 0 42.5 0C65.9721 0 85 19.0279 85 42.5Z" fill="#17B26A"/>
                            <path d="M63.75 29.75L49.431 45.7435C43.7569 52.0812 40.9199 55.25 37.1875 55.25C33.4551 55.25 30.6181 52.0812 24.944 45.7435L21.25 41.6175" stroke="white" stroke-width="4" stroke-linecap="round"/>
                            </svg>
                        </Box>
                        <Typography sx={{ m: "auto", background: 'transparent', color:'#3D3D3D', fontSize: '18px', fontWeight: '500', textAlign: "center", mt: "20px", }}>All your signers have been imported.</Typography>
                    </Box>
                </Box>
            </Modal>
            {loader && < Loader />}
        </>
    );
}
